"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TeamOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M12 8a4 4 0 014 4.06v1.23a6.44 6.44 0 01-2 4.35 2 2 0 001 3.43l1.73.33c3 .73 3.25 1.9 3.25 3.46V28H4v-3.14c0-1.57.24-2.74 3.25-3.46L9 21a2 2 0 00.95-3.41A6.33 6.33 0 018 13.29v-1.24A4 4 0 0112 8m0-2a6 6 0 00-6 6.06v1.23a8.34 8.34 0 002.54 5.79l-1.71.37c-4 1-4.83 3-4.83 5.41v3.43A1.72 1.72 0 003.71 30h16.58A1.72 1.72 0 0022 28.29v-3.43c0-2.39-.79-4.45-4.83-5.41l-1.77-.34a8.4 8.4 0 002.6-5.82v-1.23A6 6 0 0012 6z"/><path d="M29 30h-4a1 1 0 010-2h3v-5.1c0-2.15-.67-3.64-4-4.44l-1.72-.33a1 1 0 01-.81-.69.92.92 0 01.27-1 7.45 7.45 0 002.26-5.1v-1.17A5.09 5.09 0 0019 5a4.8 4.8 0 00-1.64.29 1 1 0 11-.69-1.88A6.85 6.85 0 0119 3a7.08 7.08 0 017 7.16v1.18a9.26 9.26 0 01-1.73 5.17c5.05 1.21 5.69 4 5.69 6.39V29a1.07 1.07 0 01-.96 1z"/>';
var TeamOutlineSVG = function TeamOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.TeamOutlineSVG = TeamOutlineSVG;
TeamOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(TeamOutlineSVG);
exports.default = _default;